import { environment } from "@environments/environment";

export class ApiUrlConstant {
  static readonly gateWayUrl = environment.gateWayUrl;
  static readonly commServiceUrl = environment.commServiceUrl;
  static readonly semServiceUrl = environment.semServiceUrl;
  static readonly metaUrl = environment.metaUrl;
}
